{
  "sharedDocuments": {
    "sharedDocuments": "Delade dokument",
    "sharedWith": "Delat med",
    "shareButton": "Dela med underorganisationer",
    "shareDescription": "Välj vilka underorganisationer som ska se dokumentet när det har en publicerad version.",
    "share": "Dela",
    "documentShared": "Dokumentet har delats",
    "sharedByGroup": "Delat av {{name}}",
    "sharedToGroup": "Delat till {{name}}",
    "sharedBy": "Delat av",
    "adopt": "Anta",
    "adopted": "Antaget",
    "notAdopted": "Ej antaget",
    "adoptedDetails": "Antaget {{date}} av {{name}}",
    "documentAdopted": "Dokumentet har antagits",
    "readersTitle": "Läsare",
    "inviteReaders": "Bjud in läsare",
    "inviteReadersDescription": "Bjud in läsare från din organisation. Läsuppföljningen är intern för din organisation.",
    "markAsRead": "Markera som läst",
    "document": "Dokument",
    "byOrganisation": "Av organisation",
    "toOrganisation": "Till organisation",
    "readersOverview": "Läsare (accepterat / inbjudna)",
    "noSharedDocuments": "Inga delade dokument",
    "invited": "Inbjudna",
    "opened": "Öppnade",
    "read": "Lästa"
  }
}
